import React, { useState, useEffect } from "react";
import Modal from '@mui/material/Modal';
import { styled } from "@mui/system";
import "../Admin/table.css"
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Checkbox,
    Select,
    MenuItem,
    Button,
    Grid,
} from "@mui/material";
const ViewScheduleMetting = ({ committeName, memberType }) => {
    const [isPreview, setIsPreview] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState('');
    const [editPreviewButton, seteditPreviewButton] = useState(false);
    const [isFrozen, setIsFrozen] = useState(false);
    const [ishideInitalFields, sethideInitalFields] = useState(true)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fieldValues, setFieldValues] = useState({
        field1: '',
        field2: '',
        field3: ''
    });
    const [formData, setFormData] = useState({
        districtName: '',
        blockName: '',
        gramPanchayat: '',
        sabhaDate: '',
        facilitator: '',
        panchayatSecretaryName: '',
        panchayatSecretaryMobile: '',
        sarpanchName: '',
        sarpanchMobile: '',
        panchayatAddress: '',
        panchayatPinCode: '',
        reason: ''
    });

    const [errors, setErrors] = useState({
        districtName: false,
        blockName: false,
        gramPanchayat: false,
        sabhaDate: false,
        facilitator: false,
        panchayatSecretaryName: false,
        panchayatSecretaryMobile: false,
        sarpanchName: false,
        sarpanchMobile: false,
        panchayatAddress: false,
        panchayatPinCode: false,
        reason: false
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [id]: false
        }));
    };

    const handleReset = () => {
        setFormData({
            districtName: '',
            blockName: '',
            gramPanchayat: '',
            sabhaDate: '',
            facilitator: '',
            panchayatSecretaryName: '',
            panchayatSecretaryMobile: '',
            sarpanchName: '',
            sarpanchMobile: '',
            panchayatAddress: '',
            panchayatPinCode: '',
            reason: ''
        });
        setErrors({});
        setIsPreview(false);
        setStatusMessage('');
    };
    const handleSaveAndPreview = () => {
        const newErrors = {
            districtName: !formData.districtName,
            blockName: !formData.blockName,
            gramPanchayat: !formData.gramPanchayat,
            sabhaDate: !formData.sabhaDate,
            facilitator: !formData.facilitator,
            panchayatSecretaryName: !formData.panchayatSecretaryName,
            panchayatSecretaryMobile: !formData.panchayatSecretaryMobile,
            sarpanchName: !formData.sarpanchName,
            sarpanchMobile: !formData.sarpanchMobile,
            panchayatAddress: !formData.panchayatAddress,
            panchayatPinCode: !formData.panchayatPinCode,
            reason: !formData.reason,
        };

        setErrors(newErrors);

        if (Object.values(newErrors).includes(true)) {
            return;
        }
        setIsPreview(true);
        sethideInitalFields(false);
    };

    const handleFreeze = () => {
        if (isFrozen) {
            setStatusMessage('Record unfreezed successfully.');
            seteditPreviewButton(true)
            setIsModalOpen(true);
        } else {
            setStatusMessage('Record freeze successfully.');
            seteditPreviewButton(false);

        }
        setIsFrozen(!isFrozen);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setFieldValues(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        setIsModalOpen(false);
    };


    const handleBackPrivew = () => {
        setIsPreview(false)
        sethideInitalFields(true)
        setStatusMessage('');
    };

    const handleEditPrivew = () => {
        setIsPreview(false)
        sethideInitalFields(true)
        setStatusMessage('');
    }

    const departments = [
        "Department of Agriculture",
        "Department of Animal Husbandry and Dairying",
        "Department of Art and culture",
        "Department of Chemicals & Petrochemicals",
        "Department of Disaster Management",
        "Department of Drinking Water",
    ];




    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        backgroundColor: "#F5F5F5",
        fontWeight: "bold",
    }));

    const StyledSrNoCell = styled(TableCell)(({ theme }) => ({
        backgroundColor: '#F5F5F5',
    }));

    return (
        <div className="container-fluid" style={{ height: "91vh" }}>
            <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px",fontWeight:"bold"}}>Schedule Meeting</h2>
           
            {statusMessage && (
                <div className="container-fluid" style={{ marginTop: "16px" }}>
                    <h4>Status: <span style={{ color: "green" }}>{statusMessage}</span></h4>
                </div>
            )}
           
                <>
                    <div className="row" style={{ margin: "16px 0" }}>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>District Name</label>
                            <p>{formData.districtName}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Block Name</label>
                            <p>{formData.blockName}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Gram Panchayat</label>
                            <p>{formData.gramPanchayat}</p>
                        </div>
                    </div>
                    <div className="row" style={{ margin: "16px 0" }}>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Sabha Date</label>
                            <p>{formData.sabhaDate}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Facilitator</label>
                            <p>{formData.facilitator}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Offical Representative Name</label>
                            <p>{formData.panchayatSecretaryName}</p>
                        </div>
                    </div>
                    <div className="row" style={{ margin: "16px 0" }}>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Offical Representative Mobile</label>
                            <p>{formData.panchayatSecretaryMobile}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Sarpanch Name</label>
                            <p>{formData.sarpanchName}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Sarpanch Mobile</label>
                            <p>{formData.sarpanchMobile}</p>
                        </div>
                    </div>
                </>
            
                <>
                    <div className="row" style={{ marginTop: "20px" }}>
                        <div className="col text-start">
                            {editPreviewButton && (
                                <button
                                    type="button"
                                    className="btn"
                                    style={{ backgroundColor: "#EFEBF1", width: "15%" }}
                                    onClick={handleEditPrivew}
                                >
                                    Edit
                                </button>
                            )}
                        </div>
                        <div className="col text-end">
                            <button
                                type="button"
                                className="btn"
                                style={{ backgroundColor: "#EFEBF1", marginRight: "20px", width: "15%" }}
                                onClick={handleBackPrivew}
                            >
                                Back
                            </button>
                            <button
                                type="button"
                                className="btn"
                                style={{ backgroundColor: "#323576", color: "#fff", marginRight: "10px", width: "15%" }}
                                onClick={handleFreeze}
                            >
                                {isFrozen ? 'Unfreeze' : 'Freeze'}
                            </button>
                            <div>
                                <Modal
                                    open={isModalOpen}
                                    onClose={handleModalClose}
                                    aria-labelledby="modal-title"
                                    aria-describedby="modal-description"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '70%',
                                            padding: '20px',
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '10px',
                                        }}
                                    >
                                        <div style={{ width: '100%', padding: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>


                                            <div className="mb-3">
                                                <span className="mb-0">Remark</span>
                                                <TextField
                                                    label="Full Width Field"
                                                    name="remark"
                                                    value={fieldValues.remark}
                                                    onChange={handleFieldChange}
                                                    fullWidth
                                                    margin="normal"
                                                />
                                            </div>
                                            <div className="mb-3" style={{ display: 'flex', gap: '10px' }}>
                                                <TextField
                                                    label="Upload Attachment"
                                                    name="uploadAttachment"
                                                    value={fieldValues.uploadAttachment}
                                                    onChange={handleFieldChange}
                                                    style={{ flex: '30%' }}
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Select Filename"
                                                    name="selectFilename"
                                                    value={fieldValues.selectFilename}
                                                    onChange={handleFieldChange}
                                                    style={{ flex: '70%' }}
                                                    margin="normal"
                                                />
                                            </div>

                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                gap: '10px',
                                            }}
                                        >
                                            <Button onClick={handleSubmit} variant="contained" color="primary">
                                                Submit
                                            </Button>
                                            <Button onClick={handleModalClose} variant="outlined" color="secondary">
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </>
           





















        </div>
    );
};
export default ViewScheduleMetting;
